/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1IndividualpaymentSharedPaymentTypesQueryResponse,
  GetApiV1IndividualpaymentSharedPaymentTypesQueryParams,
  GetApiV1IndividualpaymentSharedPaymentTypes401,
  GetApiV1IndividualpaymentSharedPaymentTypes500,
} from "../../types/individualPaymentSharedController/GetApiV1IndividualpaymentSharedPaymentTypes.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1IndividualpaymentSharedPaymentTypes } from "../../clients/individualPaymentSharedController/getApiV1IndividualpaymentSharedPaymentTypes.ts";

export const getApiV1IndividualpaymentSharedPaymentTypesQueryKey = (
  params?: GetApiV1IndividualpaymentSharedPaymentTypesQueryParams,
) =>
  [
    { url: "/api/v1/individualpayment/shared/payment-types" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1IndividualpaymentSharedPaymentTypesQueryKey = ReturnType<
  typeof getApiV1IndividualpaymentSharedPaymentTypesQueryKey
>;

export function getApiV1IndividualpaymentSharedPaymentTypesQueryOptions(
  params?: GetApiV1IndividualpaymentSharedPaymentTypesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1IndividualpaymentSharedPaymentTypesQueryKey(params);
  return queryOptions<
    GetApiV1IndividualpaymentSharedPaymentTypesQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentSharedPaymentTypes401
      | GetApiV1IndividualpaymentSharedPaymentTypes500
    >,
    GetApiV1IndividualpaymentSharedPaymentTypesQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1IndividualpaymentSharedPaymentTypes(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna apenas Billet, BilletPecegePay, CreditCardMundiPagg e CreditCardPecegePay, sem descrições repetidas. Migrado do legado EnumAsync/EPaymentType (projeção filtrada de EPaymentMethod). **(Requer Authorization para autenticação)**
 * @summary Dropdown de métodos de pagamento do pagamento individual (boleto e cartão) (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/shared/payment-types}
 */
export function useGetApiV1IndividualpaymentSharedPaymentTypes<
  TData = GetApiV1IndividualpaymentSharedPaymentTypesQueryResponse,
  TQueryData = GetApiV1IndividualpaymentSharedPaymentTypesQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1IndividualpaymentSharedPaymentTypesQueryKey,
>(
  params?: GetApiV1IndividualpaymentSharedPaymentTypesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1IndividualpaymentSharedPaymentTypesQueryResponse,
        ResponseErrorConfig<
          | GetApiV1IndividualpaymentSharedPaymentTypes401
          | GetApiV1IndividualpaymentSharedPaymentTypes500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1IndividualpaymentSharedPaymentTypesQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1IndividualpaymentSharedPaymentTypesQueryOptions(
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentSharedPaymentTypes401
      | GetApiV1IndividualpaymentSharedPaymentTypes500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
